import { struct } from 'io-ts/Decoder';

import { PackageName } from '../../../../../whole-house/canvas/PackageName';

export const Request = struct({
	packageName: PackageName,
});
